'use client';
import clsx from 'clsx';
import styles from './index.module.scss';
import { ButtonHTMLAttributes, FC, memo } from 'react';

import Preloader from '@/components/shared/Preloader';
import UIVariant from '@/enums/ui-variant.enum';
import CommonElementProps from '@/types/common-element-props.type';
import UISize from '@/enums/ui-size.enum';
type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> &
  Partial<{
    variant: UIVariant;
    size: UISize;
    isRounded: boolean;
    ellipsis: boolean;
    isLoading: boolean;
    fullWidth: boolean;
    hasOnlyIcon: boolean;
    onClick: VoidFunction;
  }> &
  CommonElementProps;

const Button: FC<Props> = ({
  children,
  onClick,
  variant = UIVariant.DARK,
  size = UISize.MEDIUM,
  className,
  disabled,
  isLoading = false,
  isRounded = false,
  hasOnlyIcon = false,
  ellipsis = false,
  fullWidth = false,
  ...props
}) => {
  const classNames = clsx(
    styles.btn,
    'horizontal-center',
    ellipsis && styles['btn--ellipsis'],
    styles[`btn--${variant}`],
    styles[`btn--${size}`],
    isRounded && styles['btn--rounded'],
    hasOnlyIcon && styles['btn--has-only-icon'],
    fullWidth && styles['btn--full-width'],
    className && className,
  );

  return (
    <button role="button" disabled={disabled} className={classNames} onClick={onClick} {...props}>
      {!isLoading && children}
      {isLoading && <Preloader />}
    </button>
  );
};

export default memo(Button) as typeof Button;
